window.style = {
  debug: 'color: green;',
  info: 'color: teal;',
  warn: 'color: orange;',
  error: 'color: red;',
}
